import { useState, useEffect } from "react";
import "./layoutselection.css";
import { Button } from "reactstrap";
import httpService from "./services/http.service";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import WarningMessage from "./components/common/warnMsg";
import SuccessMessage from "./components/common/successMsg";
import ErrorMessage from "./components/common/errorMsg";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

let LayoutSelectionEdit = (props) => {
  const [layoutName, setlayoutName] = useState("");
  const [array2, setArray2] = useState([]);
  const [propertyData, setpropertyData] = useState([]);
  const history = useHistory()

  useEffect(() => {
    setlayoutName(props.layoutName);
    setpropertyData(props.propertyData);
  }, []);

  useEffect(() => {
    loadProperty();
  }, []);

  const handlePropertyForLayout = (selectedValue) => {
    setpropertyData(selectedValue);
  };

  const ProceedToThisLayout = async () => {
    if (layoutName === "") {
      WarningMessage("Please enter the layout name");
      return;
    }
    if (propertyData.PropertyId === "") {
      WarningMessage("Please select the property")
      return;
    }
    let data = {
      name: layoutName.trim(),
      propertyData: propertyData,
      id: props.id
    };
    const Layout = await httpService
      .CreateUpdate("UpdateSelectedLayoutProp", data)
      .catch((err) => {
        return;
      });
    props.setlayoutCheck(true);
    SuccessMessage("Layout updated successfully");
  };
  const loadProperty = async () => {
    const UserId = localStorage.getItem("UserId");
    let req = {
      UserId: JSON.stringify(UserId),
    };
    let allPropertydata = await httpService
      .CreateUpdate("getallProperty", req)
      .catch((err) => {
        
        if (err && err.response && err.response.status == 401 && localStorage.getItem("UserId")) {
          ErrorMessage("Session expired, please login again")
        }
        history.push("/")
        localStorage.clear()
        return;
      });

    const arr2 = [];
    for (let i = 0; i < allPropertydata.data.length; i++) {
      let obj = {
        value: `${allPropertydata.data[i]._id}`,
        label: `${allPropertydata.data[i].Name}`,
        PropertyId: `${allPropertydata.data[i]._id}`,
      };
      if (allPropertydata.data[i]) {
        {
          arr2.push(obj);
        }
      }
    }
    setArray2(arr2);
  };

  return (
    <div>
      <b style={{ fontSize: "14px" }}>Property</b>
      <b style={{ color: "red" }}>*</b>
      <Select
        isMulti
        name="Rule Type"
        options={array2}
        value={propertyData}
        style={{ marginBottom: "15px" }}
        onChange={handlePropertyForLayout}
        className="basic-multi-select"
        classNamePrefix="select"
      />

      <label style={{ marginTop: "15px" }}>
        <b>Enter the Layout Name </b>
        <b style={{ color: "red" }}>*</b>
      </label>
      <input
        className="form-control"
        placeholder="Layout Name"
        maxLength={25}
        value={layoutName}
        onChange={(e) => {
          setlayoutName(e.target.value);
        }}
      ></input>
      <div className="row">

        <Button
          color="primary"
          onClick={ProceedToThisLayout}
          className="ButtonProceed"
        >
          Proceed
        </Button>
      </div>
    </div>
  );
};

export default LayoutSelectionEdit;
